// ═══════════════════════════════════════════════════════════
// HTTP 请求封装 — 统一超时、错误处理
// ═══════════════════════════════════════════════════════════

export class ApiError extends Error {
    constructor(status, code, message) {
        super(message);
        this.name = 'ApiError';
        this.status = status;
        this.code = code;
    }
}

export class TimeoutError extends ApiError {
    constructor(message = '请求超时') {
        super(408, 'TIMEOUT', message);
        this.name = 'TimeoutError';
    }
}

export class NetworkError extends ApiError {
    constructor(message = '网络连接错误') {
        super(0, 'NETWORK_ERROR', message);
        this.name = 'NetworkError';
    }
}

// 带超时的 fetch
export async function apiFetch(url, { timeout = 15000, method = 'GET', headers = {} } = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeout);

    try {
        const response = await fetch(url, {
            method,
            headers: {
                'Accept': 'application/json',
                'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36',
                ...headers,
            },
            signal: controller.signal,
        });

        if (!response.ok) {
            throw new ApiError(response.status, 'HTTP_ERROR', `HTTP ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (err) {
        if (err instanceof ApiError) throw err;
        if (err.name === 'AbortError') throw new TimeoutError();
        throw new NetworkError(err.message);
    } finally {
        clearTimeout(timer);
    }
}

// 调用站内代理 API（/api/search 或 /api/detail）
export async function callApi(endpoint, params, { timeout = 15000 } = {}) {
    const query = new URLSearchParams(params).toString();
    const url = `/${endpoint}?${query}`;
    return apiFetch(url, { timeout });
}

// 站点可用性测试
export async function testSiteAvailability(source, customApiUrl = '') {
    if (source === 'custom' && !customApiUrl) return false;

    const params = { wd: 'test' };
    if (source === 'custom') {
        params.customApi = customApiUrl;
    } else {
        params.source = source;
    }

    try {
        const data = await callApi('api/search', params, { timeout: 8000 });
        return data && data.code === 200 && Array.isArray(data.list);
    } catch {
        return false;
    }
}
